export default "__VITE_ASSET__TJsk90H1__"